/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".indent[_ngcontent-%COMP%]{padding-left:1rem}.contracted[_ngcontent-%COMP%]{display:none}.title[_ngcontent-%COMP%]{font-size:.7rem}"];
export { styles as styles };

